export const getFields = (metric: string, data: any) => {
    if (data) {
        let fields: Array<string>;
        switch (metric) {
            case "views":
            case "storyviews":
                fields = ["totalWebViews", "totalAppViews", "totalViews"];
                break;
            case "events":
                fields = ["totalEvents"];
                break;
            case "web":
                fields = ["totalWebViews"];
                break;
            case "app":
                fields = ["totalAppViews"];
                break;
            case "total":
                fields = ["totalViews"];
                break;
            case "video":
                fields = ["totalVideoViews"];
                break;
            case "conversion":
                fields = ["conversion"];
                break;
            case "totalReadingTime":
                fields = ["totalReadingTime"];
                break;
            case "totalVisitors":
                fields = ["totalVisitors"];
                break;
            case "appVisitors":
                fields = ["appVisitors"];
                break;
            case "webVisitors":
                fields = ["webVisitors"];
                break;
            default:
                fields = ["totalVideoViews", "totalVideoWebViews", "totalVideoAppViews"];
        }
        /* eslint-disable */
        return fields.filter((field) => {
            // get sum of each metric values
            const sum = data.map((item: any) => item[field]).reduce((a: any, b: any) => a + b, 0);
            // Don't return field if the sum of the values is zero
            if (sum !== 0) {
                return field;
            }
        });
        /* eslint-disable */
    }
    return [];
};

export const findBounds = (dataPoints: any, fields: Array<string>) => {
    const fieldValues = fields.map((f) => dataPoints.map((t: any) => t[f]));
    const values = fieldValues.reduce((p, n) => p.concat(n));
    return [Math.min(...values), Math.max(...values)];
};